import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=0216dd82&scoped=true&"
import script from "./Wallets.vue?vue&type=script&lang=ts&"
export * from "./Wallets.vue?vue&type=script&lang=ts&"
import style0 from "./Wallets.vue?vue&type=style&index=0&id=0216dd82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0216dd82",
  null
  
)

export default component.exports